export enum AssessmentPhotoType {
    KINGPIN_LANDING = 'kingpinLanding',
    AIRLINES_ELECTRICAL = 'airlinesElectrical',
    BRAKES = 'brakes',
    TIRES = 'tires',
    LIGHTS = 'lights',
    DAMAGE = 'damage',
    OTHER = 'other',
}

export enum AssessmentPhotoSubtype {
    // Kingpin and Landing Gear subtypes
    KINGPIN = 'kingpin',
    DRIVER_SIDE = 'driverSide',
    PASSENGER_SIDE = 'passengerSide',

    // Airlines and Electrical subtypes
    LEFT_AIRLINE = 'leftAirline',
    SEVEN_WAY = '7way',
    RIGHT_AIRLINE = 'rightAirline',
    LOWER_AIRLINE_ELECTRICAL = 'lowerAirlineElectrical',

    // Damage location subtypes
    FRONT_SIDE = 'frontSide',
    REAR_SIDE = 'rearSide',
    DRIVER_TOP = 'driverTop',
    CENTER_TOP = 'centerTop',
    PASSENGER_TOP = 'passengerTop',
    DRIVER_BOTTOM = 'driverBottom',
    CENTER_BOTTOM = 'centerBottom',
    PASSENGER_BOTTOM = 'passengerBottom',

    // General
    OTHER = 'other',
}
